import styled from "styled-components";

import { Tone, toneColor } from "../../utils";

export const SparkSvg = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
`;

export const SparkLinePath = styled.path<{ $tone: Tone }>`
  fill: none;
  stroke: ${({ $tone }) => toneColor($tone)};
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
`;

export const SparkAreaPath = styled.path<{ $tone: Tone }>`
  fill: ${({ $tone }) => toneColor($tone)};
  fill-opacity: 0.14;
  stroke: none;
`;
